import Vue from 'vue';
import store from 'store';
import sellerStore from 'store/indexSeller';
import {isCurrentAppSeller} from 'utils/appTypeState';
import {
  MAIN_LAYOUT_CONTAINER,
  ADD_NEW_QUEUE,
  ADD_NOTIFICATION,
  CLOSE_ALL_NOTIFICATIONS
} from 'store/modules/notifications/notifications';
import MNotificationsLayout from 'components/common/MNotification/MNotificationsLayout';

const getStoreModule = () => isCurrentAppSeller() ? sellerStore : store;

const MAX_VISIBLE_COUNT = 5;
const NOTIFICATION_DEBOUNCE_TIME = 500;
const NOTIFICATION_DISPLAY_DURATION = 5000;

const debounceNotifications = (func, delay) => {
  let timer;
  let calls = [];

  return function (...args) {
    const {text} = args[0];
    const duplicateCall = calls.find((item) => item.text === text);

    clearTimeout(duplicateCall?.id);
    timer = setTimeout(() => {
      calls = [];
    }, delay);

    if (duplicateCall) {
      duplicateCall.id = timer;
    } else {
      func(...args);
      calls.push({id: timer, text});
    }
  };
};

function showNotificationWithoutDebounce (options) {
  const storeModule = getStoreModule();

  const container = options.container ? options.container : MAIN_LAYOUT_CONTAINER;
  const isQueueExist = storeModule.getters['notifications/isExistingQueue'](container);

  if (!isQueueExist) {
    let layoutAlign = options.layout ? options.layout : 'bottomRight';
    const maxVisible = options.maxVisible ? options.maxVisible : MAX_VISIBLE_COUNT;
    const layout = new Vue({
      store: storeModule,
      render: (h) => h(MNotificationsLayout, {
        props: {
          container,
          layout: layoutAlign
        }
      })
    });

    storeModule.commit(`notifications/${ADD_NEW_QUEUE}`, {
      maxVisible,
      container,
      layout
    });

    layout.$mount();
    const parent = document.querySelector(container);
    parent.appendChild(layout.$el);
  }

  storeModule.commit(`notifications/${ADD_NOTIFICATION}`, {
    container,
    timeout: NOTIFICATION_DISPLAY_DURATION,
    ...options
  });
}

function closeAllNotifications () {
  getStoreModule().commit(`notifications/${CLOSE_ALL_NOTIFICATIONS}`);
}

const showNotification = debounceNotifications(showNotificationWithoutDebounce, NOTIFICATION_DEBOUNCE_TIME);

export {
  showNotification,
  closeAllNotifications
};
